import styled from 'styled-components';
import { useState } from 'react';

const items = [
  {
    type: 'image',
    normal: 'pic_picture@2x',
    hover: 'pic_picture_blue@2x',
    label: '上传图片',
  },
  {
    type: 'audio',
    normal: 'pic_audio@2x',
    hover: 'pic_audio_blue@2x',
    label: '上传音频',
  },
];

const getItem = inType => {
  return items.find(item => item.type === inType);
};

const Container = styled.div`
  width: 100px;
  height: 75px;
  background: #fff;
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: center;
  border-radius: 6px;
  border: 1px solid #eee;
  flex-direction: column;
  transition: all 0.3s;
  img {
    width: 30px;
    height: 30px;
  }

  &:hover {
    border-color: #1890ff;
    .is-label {
      visibility: visible;
      height: 18px;
      line-height: 18px;
      opacity: 1;
    }
  }

  .is-label {
    transition: all 0.2s;
    font-size: 12px;
    color: #1890ff;
    visibility: hidden;
    height: 0;
    opacity: 0;
  }
`;

export default props => {
  const { type } = props;
  const item = getItem(type);
  const [hovering, setHovering] = useState(false);
  const ctx = 'assets/images/v2icons';
  const status = hovering ? 'hover' : 'normal';
  const { canEdit } = nx.$root.content;

  return (
    <Container
      data-disabled={!canEdit}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}>
      <img alt={type} src={require(`common/${ctx}/${item[status]}.png`)} />
      <label className="is-label">{item.label}</label>
    </Container>
  );
};
